import {
  DispatchTripRead,
  RunBambiRunReassignedTripRead,
  RunBambiRunTripRead,
} from 'src/common/external/bambi-api/bambiApi';


export function getCalendarEventStartAndEndTime(
  trip: DispatchTripRead | RunBambiRunTripRead | RunBambiRunReassignedTripRead
) {
  return {
    start: trip.arrival_time ?? trip.scheduled_pickup_at,
    end: trip.completion_time ?? trip.scheduled_dropoff_at,
  };
}
